import request from "../request";
// 获取助推列表
export function getnewBoostList(data) {
  return request({
    url: "/ld/ksAdSocialTaskSec/getListData",
    method: "post",
    data,
  });
}

export default {
    getnewBoostList,
};
